// node modules
import * as React from "react";
import { Layout, Drawer } from "antd";
// components
import SidebarMenuComponent from "components/general/SidebarMenuComponent";
// images
import longLogo from "assets/images/long-logo.svg";
// styles
import "styles/sidebar.css";
import { useTranslation } from "react-i18next";
import { dir } from 'i18next';

const { Sider } = Layout;

const SidebarComponent = ({ userInfo }) => {
  const [visibleDrawer, setVisibleDrawer] = React.useState(false);

  const { i18n } = useTranslation();

  const handleCollapse = (collapse, type) => {
    if (type === "clickTrigger" && !collapse) {
      setVisibleDrawer(true);
    } else if (type === "responsive" && collapse) {
      setVisibleDrawer(false);
    }
  };
  const onCloseDrawer = () => {
    setVisibleDrawer(false);
  };

  return (
    <>
      {visibleDrawer ? (
        <Drawer
          data-testid="drawer"
          className="text-align-center"
          title={
            <img
              className="margin-auto clexi-logo-sidebar"
              alt="clexi"
              src={longLogo}
            />
          }
          placement={dir(i18n.language) === 'ltr' ? 'left' : 'right'}
          closable={true}
          onClose={onCloseDrawer}
          visible={visibleDrawer}
        >
          <SidebarMenuComponent userInfo={userInfo} className="margin-top-1" />
        </Drawer>
      ) : (
        <Sider
          data-testid="sider"
          className="sidebar-wrapper text-align-center"
          width={272}
          breakpoint="md"
          collapsedWidth={0}
          theme={"light"}
          onCollapse={handleCollapse}
        >
          <img
            className="margin-auto clexi-logo-sidebar"
            alt="clexi"
            src={longLogo}
          />
          <SidebarMenuComponent
            userInfo={userInfo}
            className="sidebar-menu-desktop"
          />
        </Sider>
      )}
    </>
  );
};

export default SidebarComponent;
